import { createContext, useContext } from "react";

export const ShellThemeContext = createContext("light");

export function useShellTheme() {
  return useContext(ShellThemeContext);
}
